import React, { useState } from 'react';
import { Button, Grid, TablePagination, Typography, Box } from '@mui/material';

import { t } from 'i18next';
import { gridSpacing } from '../../../store/constant';
import MainCard from '../../../component/cards/MainCard';
import { useQuestionnaires } from '../../../hooks/useQuestionnaires';

import ExistingQuestionnaireCard from './QuestionarioCard';
import BulkAssignDialog from './BulkAssignDialog';

const QuestionnaireManager = () => {
    const {
        data: existingQuestionnaires,
        paginationModel,
        setPaginationModel,
        rowsPerPageOptions,
        count
    } = useQuestionnaires();

    const [selectionMode, setSelectionMode] = useState(false);
    const [selectedQuestionnaires, setSelectedQuestionnaires] = useState([]);
    const [openAssignDialog, setOpenAssignDialog] = useState(false);

    const toggleSelection = (uuid) => {
        setSelectedQuestionnaires((prev) =>
            prev.includes(uuid) ? prev.filter((id) => id !== uuid) : [...prev, uuid]
        );
    };

    return (
        <MainCard
            border
            boxShadow={true}
            content={false}
            title={
                <Grid container alignItems="center" justifyContent="space-between">
                    <Typography variant="h4">{t('questionnaires.title2')}</Typography>
                    <Box display="flex" gap={2}>
                        {!selectionMode && (
                            <Button
                                variant="outlined"
                                onClick={() => setSelectionMode(true)}
                            >
                                {t('questionnaires.select')}
                            </Button>
                        )}
                        {selectionMode && (
                            <>
                                <Button
                                    variant="contained"
                                    onClick={() => setOpenAssignDialog(true)}
                                    disabled={selectedQuestionnaires.length === 0}
                                >
                                    {t('questionnaires.assign_selected')}
                                </Button>
                                <Button
                                    variant="outlined"
                                    color="secondary"
                                    onClick={() => {
                                        setSelectionMode(false);
                                        setSelectedQuestionnaires([]);
                                    }}
                                >
                                    {t('questionnaires.cancel')}
                                </Button>
                            </>
                        )}
                    </Box>
                </Grid>
            }
        >
            <Grid
                container
                spacing={2}
                justifyContent="space-around"
                alignItems="start"
                marginTop={2}
                marginBottom={2}
            >
                <Grid item xs={11}>
                    <Grid container spacing={gridSpacing} justifyContent="start">
                        {Array.isArray(existingQuestionnaires) &&
                            existingQuestionnaires.map((q) => (
                                <Grid item key={q.uuid} lg={4} md={6} sm={12} xs={12}>
                                    <ExistingQuestionnaireCard
                                        questionnaire={q}
                                        selectionMode={selectionMode}
                                        selected={selectedQuestionnaires.includes(q.uuid)}
                                        onToggleSelect={() => toggleSelection(q.uuid)}
                                    />
                                </Grid>
                            ))}
                    </Grid>
                </Grid>
            </Grid>
            <TablePagination
                component="div"
                count={count}
                page={paginationModel.page}
                onPageChange={(event, newPage) =>
                    setPaginationModel({ ...paginationModel, page: newPage })
                }
                rowsPerPage={paginationModel.pageSize}
                onRowsPerPageChange={(event) =>
                    setPaginationModel({
                        ...paginationModel,
                        page: 0,
                        pageSize: parseInt(event.target.value, 10)
                    })
                }
                rowsPerPageOptions={rowsPerPageOptions}
            />

            <BulkAssignDialog
                open={openAssignDialog}
                onClose={() => setOpenAssignDialog(false)}
                questionnaireUUIDs={selectedQuestionnaires}
            />
        </MainCard>
    );
};

export default QuestionnaireManager;
